import { render } from "./StoreChainListView.vue?vue&type=template&id=4da9a3f7"
import script from "./StoreChainListView.vue?vue&type=script&lang=js"
export * from "./StoreChainListView.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__